/**
 * 숫자 표시 규칙 한 곳.
 *
 * 가동률이 0.986~1.000 사이에 몰려 있으므로 **소수 둘째 자리(%)까지 보여야
 * 비교가 성립한다** — `99%` 로 반올림하면 1위와 40위가 같은 값이 된다.
 * 결측은 `—` 로 쓴다. 0 이 아니다.
 */

export const DASH = '—'

/** 비율 → 백분율 문자열. null 이면 대시 — 0% 로 쓰지 않는다. */
export function pct(v: number | null | undefined, digits = 2): string {
  if (v == null || Number.isNaN(v)) return DASH
  return `${(v * 100).toFixed(digits)}%`
}

/** 차이(포인트). 부호를 항상 붙인다 — 방향이 곧 의미다. */
export function pp(v: number | null | undefined, digits = 2): string {
  if (v == null || Number.isNaN(v)) return DASH
  return `${v >= 0 ? '+' : '−'}${(Math.abs(v) * 100).toFixed(digits)}p`
}

export function int(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return DASH
  return Math.round(v).toLocaleString('ko-KR')
}

/** 분 → 사람이 읽는 관측량 */
export function minutes(v: number | null | undefined): string {
  if (v == null || Number.isNaN(v)) return DASH
  if (v < 1440) return `${Math.round(v).toLocaleString('ko-KR')}분`
  if (v < 1440 * 365) return `${Math.round(v / 1440).toLocaleString('ko-KR')}일`
  return `${Math.round(v / 1440 / 365).toLocaleString('ko-KR')}년`
}

/**
 * 축 라벨 서식기 — **한 축의 자릿수는 하나여야 한다.**
 *
 * 값마다 자릿수를 다르게 주면 `82%, 84%, 87%, 93.0%, 99.0%` 처럼 눈금이
 * 불규칙해 보이고, 읽는 사람이 없는 규칙을 찾게 된다. 자릿수는 축이 덮는
 * 폭(span)에서 한 번만 정한다.
 */
export function pctAxis(span: number): (v: number) => string {
  const digits = span >= 0.2 ? 0 : span >= 0.02 ? 1 : 2
  return (v: number) => `${(v * 100).toFixed(digits)}%`
}

/** 마크 지름은 넓이가 아니라 길이로 읽히므로 √n 으로 매핑한다 */
export function markSize(n: number, min: number, max: number, scale = 0.36): number {
  return Math.max(min, Math.min(max, Math.sqrt(Math.max(n, 1)) * scale))
}
